var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationAppSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#FFEACC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3399 20.49L24.3399 18.83C24.1299 18.46 23.9399 17.76 23.9399 17.35V14.82C23.9399 12.47 22.5599 10.44 20.5699 9.49C20.0499 8.57 19.0899 8 17.9899 8C16.8999 8 15.9199 8.59 15.3999 9.52C13.4499 10.49 12.0999 12.5 12.0999 14.82V17.35C12.0999 17.76 11.9099 18.46 11.6999 18.82L10.6899 20.49C10.2899 21.16 10.1999 21.9 10.4499 22.58C10.6899 23.25 11.2599 23.77 11.9999 24.02C13.9399 24.68 15.9799 25 18.0199 25C20.0599 25 22.0999 24.68 24.0399 24.03C24.7399 23.8 25.2799 23.27 25.5399 22.58C25.7999 21.89 25.7299 21.13 25.3399 20.49Z",
    fill: "#FF671E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8301 26.01C20.4101 27.17 19.3001 28 18.0001 28C17.2101 28 16.4301 27.68 15.8801 27.11C15.5601 26.81 15.3201 26.41 15.1801 26C15.3101 26.02 15.4401 26.03 15.5801 26.05C15.8101 26.08 16.0501 26.11 16.2901 26.13C16.8601 26.18 17.4401 26.21 18.0201 26.21C18.5901 26.21 19.1601 26.18 19.7201 26.13C19.9301 26.11 20.1401 26.1 20.3401 26.07C20.5001 26.05 20.6601 26.03 20.8301 26.01Z",
    fill: "#FF671E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAppSetting);
export default __webpack_public_path__ + "static/media/notification-app-setting.abf1e317701a413fc5f900890b3aac16.svg";
export { ForwardRef as ReactComponent };